/**
  * @class meleActorRadarConfig
  * @description
  *
  * # Purpose
  * Implements `<mele-actor-radarconfig>` custom web element for showing radar configuration from mmRadarConfig in <mele-channel>
  */

import meleActor from 'meleActor'

const PROPERTIES = _.extend({}, {
  mode: { description: 'radar run mode', type: 'string', readonly: true },
}, meleActor._properties)

export default class meleActorRadarConfig extends meleActor {
  init() {
    super.init()
    this.listener = this.closest('.mele-player').listener
  }

  message({ action, params }) {
    const { mode, direction_limit, lanes_limit, speed_limit, speed_trigger } = params
    this.mode = mode
    this.innerHTML = `
      <mele-image icon="radar.${direction_limit}${lanes_limit}"></mele-image>
      <speed>${speed_limit}</speed>
      <mode>${this.translate('radar.mode.'+mode)}</mode>
    `
    if(this.cleaner) clearTimeout(this.cleaner)
    this.cleaner = setTimeout(() => {
      this.mode = ''
    }, 2000)
  }
} // class meleActorRadarConfig

meleActorRadarConfig._properties = PROPERTIES
meleActorRadarConfig.observedAttributes = _.keys(PROPERTIES)
window.customElements.define('mele-actor-radarconfig', meleActorRadarConfig)
